import type { ReactNode } from 'react'
import { PostHogProvider } from 'posthog-js/react'
import { isLocal, isProduction } from '@/utils/global/env'

import { buildPostHogOptions } from '@/utils/global/posthog'

export const PostHogWrapper = ({ children }: { children: ReactNode }) => {
  const posthogKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY
  const posthogHost = process.env.REACT_APP_PUBLIC_POSTHOG_HOST
  const keyExists = !!posthogKey
  const hostExists = !!posthogHost
  const posthogEnabled = !isLocal && keyExists && hostExists

  if (!posthogEnabled) {
    return <>{children}</>
  }

  return (
    <PostHogProvider
      apiKey={posthogKey}
      options={buildPostHogOptions(posthogHost, !isProduction)}
    >
      {children}
    </PostHogProvider>
  )
}

export default PostHogWrapper
